import { render } from "./Grow.vue?vue&type=template&id=5b9382b0&scoped=true"
import script from "./Grow.vue?vue&type=script&lang=js"
export * from "./Grow.vue?vue&type=script&lang=js"

import "./Grow.vue?vue&type=style&index=0&id=5b9382b0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9382b0"]])

export default __exports__